// ─────────────────────────────────────────────────────────────────────────────
// 🔑 THE PER-LOAN TITLE LINE(S), PRICED FOR THE LOAN THIS CARD SHOWS (2026-10-16).
//
// The T-19 endorsement is a percentage of TDI's basic premium on the loan amount. The SmartEstimate card
// re-prices live as the borrower moves the price, so it prices T-19 itself from the inputs GET
// /api/fee-schedule serves as `titleComputed` — TDI's tables and rule, from the backend's one extraction
// (backend/constants/tdiTitleRates.js). This mirrors backend basicPremium / t19Premium; backend
// test/leSurfaceAgreement renders the card and fails if any figure differs from the native LE.
// ─────────────────────────────────────────────────────────────────────────────

function basicPremium(def, face) {
  if (!(face > 0) || !def || !Array.isArray(def.band)) return null;
  if (face <= 100000) {
    const row = def.band.find(([amt]) => face <= amt);
    return row ? row[1] : null;
  }
  const ex = (def.excess || []).find((e) => face >= e.low && (e.high === null || face <= e.high));
  if (!ex) return null;
  return Math.round((face - ex.subtract) * ex.multiply) + ex.add;
}

/** The computed lines for one loan, shaped like the served titleLines ({ key, label, amount }). Amount null if unpriceable. */
export function computedTitleLines(defs, loanAmount) {
  if (!Array.isArray(defs)) return [];
  return defs.map((d) => {
    let amount = null;
    if (d.compute === 'tdi_r29_t19_residential') {
      const basic = basicPremium(d, Number(loanAmount));
      if (basic !== null) amount = Math.max(Math.round(basic * d.pct) / 100, d.minimum);
    }
    // As the LE prints it: nearest whole dollar (backend constants/feeSchedule leRound).
    return { key: d.figureKey, label: d.label, amount: amount === null ? null : Math.round(amount), exactAmount: amount };
  });
}
